import { useNotify } from '@/hooks';
import { useGraphContext } from '../../context';
import {
  createUpdateNodeOptionTypeCommand,
  createUpdateNodeOptionValueCommand,
} from '../../lib/commands';
import { OptionType } from '@morph-mapper/types';
import { NodeId } from '../../types';

export const useCommand = (nodeId: NodeId) => {
  /* Context state */
  const [applyCommand] = useGraphContext(({ cmd }) => [cmd.applyCommand]);
  /* Hooks */
  const { warn } = useNotify();

  const handleUpdate = (key: string, value: unknown) => {
    const result = applyCommand(
      createUpdateNodeOptionValueCommand(nodeId, key, value)
    );
    if (result.isErr()) {
      warn(result.error.message);
    }
  };

  const handleTypeChange = (key: string, type: OptionType) => {
    const result = applyCommand(
      createUpdateNodeOptionTypeCommand(nodeId, key, type)
    );
    if (result.isErr()) {
      warn(result.error.message);
    }
  };

  return {
    handleUpdate,
    handleTypeChange,
  };
};
